"use client";

import Link from "next/link";
import { Linkedin, Instagram, Facebook, Twitter, } from "lucide-react";
import NewsletterForm from "../frontend/newsletter/Client/NewsLetterForm";

const Footer = () => {
  return (
    <footer className="relative w-full bg-primary text-gray-300 px-6 md:px-16 py-10 overflow-hidden">
      <div className="container mx-auto flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        
        {/* Subscribe Section */}
        <div className="flex flex-col gap-3 w-full md:w-1/3">
          <label htmlFor="email" className="text-white font-medium">
            Subscribe :
          </label>
          <NewsletterForm />
        </div>

        {/* Social Media */}
        <div className="flex justify-center md:justify-start gap-4">
          {[
            { icon: <Linkedin className="w-5 h-5" />, href: "#" },
            { icon: <Instagram className="w-5 h-5" />, href: "#" },
            { icon: <Facebook className="w-5 h-5" />, href: "#" },
            { icon: <Twitter className="w-5 h-5" />, href: "#" },
          ].map((s, i) => (
            <Link
              key={i}
              href={s.href}
              className="w-10 h-10 rounded-full bg-[#2a2c34] flex items-center justify-center text-white hover:bg-[#3a3d47] transition"
            >
              {s.icon}
            </Link>
          ))}
        </div>

        {/* Links + Copyright */}
        <div className="flex flex-col items-center md:items-end gap-3 text-sm">
          <div className="flex flex-col md:flex-row gap-3 md:gap-6 text-white text-center md:text-right">
            <Link href="/contact-us" className="hover:text-gray-400">
              Contact Us
            </Link>
            <Link href="/privacy-policy" className="hover:text-gray-400">
              Privacy Policy
            </Link>
            <Link href="/cookie-policy" className="hover:text-gray-400">
              Cookie Policy
            </Link>
          </div>
          <p className="text-white/60 text-xs md:text-sm">
            &copy; {new Date().getFullYear()} MMMLaw Nakuru. All Rights Reserved.
          </p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
